export default "__VITE_ASSET__BNS7LW_Z__"